import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import { deleteSmsServiceProvider } from "data/server_apis/thirdParty";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSmsServiceProvidersThunk,
  smsServiceProviderSelector,
} from "store/reducers/third_party/smsProviderSlice";
import SmsProviderEditDialog from "./menu/SmsProviderEditDialog";
import SmsProviderItem from "./SmsProviderItem";

const SmsProviderList = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  useEffect(() => {
    dispatch(getSmsServiceProvidersThunk());
  }, []);
  const smsServiceProviders = useSelector(smsServiceProviderSelector.selectAll);

  const removePaymentType = (id) => {
    dispatch(deleteSmsServiceProvider(id));
  };
  const { status } = useSelector((state) => state.smsProvider);
  const [currentItem, setCurrentItem] = React.useState(null);
  const [openPaymentTypeUpdate, setOpenPaymentTypeUpdate] =
    React.useState(false);

  const handlePaymentTypeClose = () => {
    setOpenPaymentTypeUpdate(false);
  };
  const handleEditClick = (item) => {
    setCurrentItem(item);
    setOpenPaymentTypeUpdate(true);
  };
  return (
    <Box padding={2}>
      <Box
        sx={{
          backgroundColor: "#e7ebf0",
          borderRadius: 2,
          flex: 1,
        }}
        padding={1}
      >
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>ID </TableCell>
                <TableCell align="center">
                  {isSmallScreen ? "Payment name" : "Name"}
                </TableCell>
                <TableCell align="center">Code</TableCell>
                <TableCell align="center" sx={{ minWidth: 200 }}>
                  Credential format
                </TableCell>
                <TableCell align="center" sx={{ width: 50 }}>
                  &nbsp;
                </TableCell>

                <TableCell align="center" sx={{ width: 50 }}>
                  &nbsp;
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {status?.loading === "get" ? (
                <>
                  {Array(4)
                    .fill("")
                    .map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {Array(6)
                          .fill("")
                          .map((i, j) => (
                            <TableCell
                              align="center"
                              component="th"
                              scope="row"
                              key={j}
                            >
                              <Skeleton animation="wave" />
                            </TableCell>
                          ))}
                      </TableRow>
                    ))}
                </>
              ) : (
                <>
                  {smsServiceProviders.map((item) => (
                    <SmsProviderItem item={item} key={item.id} handleEditClick={handleEditClick}/>
                  ))}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <SmsProviderEditDialog
        open={openPaymentTypeUpdate}
        handleClose={handlePaymentTypeClose}
        item={currentItem}
      />
    </Box>
  );
};

export default SmsProviderList;
